(() => {
  customElements.whenDefined('modal-dialog').then(async () => {
    const DRAFT_ORDER_URL_PARAM = 'do';
    const DRAFT_ORDER_FETCH_PARAM = 'do';

    const getUrlParam = (key) => {
      const params = new URLSearchParams(window.location.search);
      return params.get(key);
    };

    const orderId = getUrlParam(DRAFT_ORDER_URL_PARAM);
    if (!orderId) return;

    const modalOpener = document.querySelector('[data-modal="modal-cart-prep"] button');
    const modalText = document.querySelector('#cart-prep-modal-text');
    const modalLoadingIcon = document.querySelector('#cart-prep-modal-loading-icon');

    const updateCartPrepStatus = (text, isLoading = true, error = false) => {
      if (modalText) modalText.innerHTML = text;
      modalText?.classList[error ? 'add' : 'remove']('alert', 'bg-error-bg', 'text-error-text');

      modalLoadingIcon?.classList[isLoading ? 'add' : 'remove']('is-loading');
    };

    if (modalOpener) {
      modalOpener.click();
    }

    updateCartPrepStatus(
      modalText?.dataset.stepGettingDetails || 'Getting details.',
      true,
      false
    );

    // Stub: your future secure endpoint
    const SERVER_ENDPOINT = `https://jetcharge.com.au/wholesale/index.php`;

    const params = new URLSearchParams();
    params.append(DRAFT_ORDER_FETCH_PARAM, orderId);

    try {
      // Call server with POST request to fetch draft order data
      const res = await fetch(SERVER_ENDPOINT, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: params.toString()
      });

      if (!res.ok) {
        updateCartPrepStatus('There was an error setting up your cart. (Error code: #1)', false, true);
        console.log('Failed to fetch draft order');
        return;
      }

      const {data} = await res.json();
      const lineItems = data?.lineitems?.nodes || data?.draftOrder?.lineItems?.nodes;
      const cartNote = data?.note2 || data?.draftOrder?.note2 || '';

      if (!Array.isArray(lineItems)) {
        updateCartPrepStatus('There was an error setting up your cart. (Error code: #2)', false, true);
        console.log('Invalid line items');
        return;
      }

      updateCartPrepStatus(
        modalText?.dataset.stepBuilding || 'Building cart.',
        true,
        false
      );

      // Clear cart first
      await fetch('/cart/clear.js', {method: 'POST'});

      // Set cart note if present
      if (cartNote) {
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({note: cartNote})
        });
      }

      // Add each line item
      for (const item of lineItems) {
        const payload = {
          id: item.variant.id.split('/').pop(),
          quantity: item.quantity
        };

        if (item.customAttributes && Object.keys(item.customAttributes).length > 0) {
          if (Array.isArray(item.customAttributes)) {
            const properties = {};
            item.customAttributes.forEach(attr => {
              if (attr.key && attr.value != null) {
                properties[attr.key] = attr.value;
              }
            });
            payload.properties = properties;
          } else {
            payload.properties = item.customAttributes;
          }
        }

        await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(payload)
        });
      }

      updateCartPrepStatus(
        modalText?.dataset.stepReloading || 'Reloading.',
        true,
        false
      );

      // Remove the 'order' param and reload the cart page
      const url = new URL(window.location.href);
      url.searchParams.delete(DRAFT_ORDER_URL_PARAM);
      window.location.replace(url.toString());

    } catch (err) {
      updateCartPrepStatus('There was an error setting up your cart. (Error code: #3)', false, true);
      console.log('Error with setting up your cart:', err);
    }
  });
})();
